<template>
  <div id="app" :class="$bpManager.classes">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>

</style>
